<div class="bm-card-body">
  <h2 class="bm-card-title">{{ getTitle() }}</h2>
  <table class="bm-table bm-table-xs">
    <tr>
      <th>id</th>
      <th>Einsatztermin</th>
      @if (showTravelstart()) {
        <th>Abfahrt</th>
      }
      <th>Techniker</th>
      <th>Rufnummer</th>
      <th>TicketID</th>
      <th>Ort</th>
      <th>Projekt</th>
      <th>Anreise</th>
      @if (showCreated()) {
        <th>erstellt</th>
      }
      <th>Aktionen</th>
    </tr>
    @for (job of jobs | qmJobType: jobType; track $index) {
      <tr [class.locked]="isLocked(job)">
        <th>{{ job.id }}</th>
        <td>{{ job.operation_date | date: "dd.MM.yyyy HH:mm" }}</td>
        @if (showTravelstart()) {
          <td>{{ job.date_travel_start | date: "dd.MM.yyyy HH:mm" }}</td>
        }
        <td>{{ job.technician_name }}</td>
        <td>
          <a href="tel:{{ job.technician_phone }}">{{ job.technician_phone }}</a>
        </td>
        <td>
          <a
            href="/a/ticket/{{ job.ticket_id }}?qmJob={{ job.id }}&operation_id={{ job.operation_id }}"
            target="_blank"
          >
            {{ job.ticket_id }}
          </a>
        </td>
        <td>{{ job.job_city }}</td>
        <td>{{ job.project_name }}</td>
        <td>{{ job.travel_distance | number: "1.0-0" }} km / {{ job.travel_duration | number: "1.0-0" }} min</td>
        @if (showCreated()) {
          <td>{{ job.created_at | date: "dd.MM.yyyy HH:mm" }}</td>
        }
        <td>
          <div class="bm-join">
            <button
              class="bm-join-item bm-btn bm-btn-sm bm-tooltip"
              (click)="setLock(job.id)"
              data-tip="Vorgang sperren"
              *ngIf="!isLocked(job)"
            >
              <fa-icon [icon]="['far', 'lock']"></fa-icon>
            </button>
            <button
              class="bm-join-item bm-btn bm-btn-sm bm-tooltip"
              (click)="setUnlock(job.id)"
              data-tip="Vorgangssperre aufheben"
              *ngIf="isLocked(job)"
            >
              <fa-icon [icon]="['far', 'lock-open']"></fa-icon>
            </button>
            <button class="bm-join-item bm-btn bm-btn-sm bm-tooltip" (click)="setDone(job.id)" data-tip="erledigt">
              <fa-icon [icon]="['fas', 'check']"></fa-icon>
            </button>
            <button class="bm-join-item bm-btn bm-btn-sm bm-tooltip" (click)="setDelete(job.id)" data-tip="löschen">
              <fa-icon [icon]="['far', 'trash']"></fa-icon>
            </button>
            <button
              class="bm-join-item bm-btn bm-btn-sm bm-tooltip"
              (click)="setFollowUp(job.id)"
              data-tip="Wiedervorlage in 15min"
            >
              <fa-icon [icon]="'history'"></fa-icon>
            </button>
          </div>
        </td>
      </tr>
    }
  </table>
</div>
